const subscribeToTolstoyAddToCartClick = () => {
  const myCallback = () => {
    setTimeout(async () => {
      window.BAO.dispatchEvent(window.BAO.EVENTS.PUSH_CART.TOLSTOY_CHANGED, {})
    }, 1000)
  }

  const options = {}

  window.tolstoyWidget.subscribe('tolstoy_add_to_cart', myCallback, options)
}

if (window.tolstoyWidget) {
  subscribeToTolstoyAddToCartClick()
} else {
  window.addEventListener('tolstoyWidgetReady', () => {
    subscribeToTolstoyAddToCartClick()
  })
}
